import { createAction, props } from '@ngrx/store';
import { ObjectSource } from 'src/app/public/common/constants/general-basic-data';
import { JobAction } from 'src/app/public/keep/constants/keep-basic-data';
import { PostingStatus, PostingAction } from 'src/app/public/keep/constants/posting-basic-data';
import { JobItem } from 'src/app/public/keep/models/job-item.model';
import { JobModif } from 'src/app/public/keep/models/job-modif.model';
import { Job } from 'src/app/public/keep/models/job.model';
import { Posting } from 'src/app/public/keep/models/posting.model';


export class KeepActions {

     // Jobs 

    public static jobNewSubmit = createAction(
        '[Car Component] job New Submit',
        props <{ job: Job, objectSource: ObjectSource }> ()
    );

    public static jobItemNewSubmit = createAction(
        '[Car Component] jobItem New Submit',
        props <{ jobItem: JobItem, objectSource: ObjectSource }> ()
    );
    /*
    public static jobNewSuccess = createAction(
        '[Car Component] job New Success',
        props <{ job: Job }> ()
    );
    

    public static jobUpdateSubmit = createAction(
        '[Car Component] job Update Submit',
        props <{ job: Job, objectSource: ObjectSource }> ()
    );
    */

    public static jobActionSubmit = createAction(
        '[Car Component] job Action Submit',
        props <{ jobAction: JobAction, job: Job | JobModif, objectSource: ObjectSource }> ()
    );

    public static jobItemUpdateSubmit = createAction(
        '[Car Component] jobItem Update Submit',
        props <{ jobItem: JobItem, objectSource: ObjectSource }> ()
    );

    public static jobItemDeleteSubmit = createAction(
        '[Car Component] jobItem Delete Submit',
        props <{ jobItemId: number, objectSource: ObjectSource }> ()
    );

    public static jobUpsertSuccess = createAction(
        '[Car Component] job Upsert Success',
        props <{ job: Job, objectSource: ObjectSource }> ()
    );

    public static jobStatusUpdateSubmit = createAction(
        '[Car API] Update job status submit',
        props <{ jobId: string, status: string, objectSource: ObjectSource }> ()
    );

    public static jobItemStatusUpdateSubmit = createAction(
        '[Car API] Update jobItem status submit',
        props <{ jobItemId: string, status: string, objectSource: ObjectSource }> ()
    );
    /*
    public static jobStatusUpdateSuccess = createAction(
        '[Car API] Update job status success',
        props <{ job: Job }> ()
    );
    */

    public static jobRescheduleSubmit = createAction(
        '[Car Component] job Schedule Submit',
        props <{ jobId: string, schedDate: string, objectSource: ObjectSource }> ()
    );
    /*
    public static jobRescheduleSuccess = createAction(
        '[Car Component] job Schedule Success',
        props <{ job: Job }> ()
    );
    */

    public static connectAppointmentSubmit = createAction(
        '[Car Component] job Connect Appointment Submit',
        props <{ jobId: string, appointmentId: string, connect: boolean, objectSource: ObjectSource }> ()
    );

    /*
    public static connectAppointmentSSuccess = createAction(
        '[Car Component] job Connect Appointment Success',
        props <{ jobId: string, appointmentId: string, connect: boolean }> ()
    );
    */

    public static postingActionSubmit = createAction(
        '[Car Component] posting Action Submit',
        props <{ postingAction: PostingAction, posting: Posting, objectSource: ObjectSource }> ()
    );

    public static postingStatusUpdateSubmit = createAction(
        '[Car API] Update posting status submit',
        props <{ postingId: number, status: PostingStatus, objectSource: ObjectSource }> ()
    );

    public static postingUpsertSuccess = createAction(
        '[Car Component] posting Upsert Success',
        props <{ posting: Posting, objectSource: ObjectSource }> ()
    );

}

